import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { ResizeDirective } from '../../../shared/directives/resize.directive';

@Component({
  selector: 'app-unsubscribed-base-page',
  templateUrl: './unsubscribed-base-page.component.html',
  standalone: true,
  imports: [HeaderComponent, RouterLink, ResizeDirective, ButtonDirective, RouterOutlet],
})
export class UnsubscribedBasePageComponent {}
